export default {

    namespaced: true,


    state: { /* = data */
        
        cache_items: [],
        items: []

    },


    getters: { /* = Computed properties, perfects to filter data an execute some calculation */

    },


    actions: { /* = Methods */

        filterItems({ commit, state }, filters) {
            let items = state.cache_items;
            if (filters.selected_type || filters.search_text) {
                items = items.filter(({ first_name, last_name, email, role_code }) =>{
                        let match = true;
                        if(filters.selected_type){
                            match = role_code.match(new RegExp(`${filters.selected_type}`, 'gi'))
                        }
                        if(match && filters.search_text){
                            match = first_name.match(new RegExp(`${filters.search_text}`, 'gi')) || 
                                    last_name.match(new RegExp(`${filters.search_text}`, 'gi')) || 
                                    email.match(new RegExp(`${filters.search_text}`, 'gi'))
                        }
                        return match;
                    })
            }

            commit('setItems', {items: items, update_cache: false})
        },

    },


    mutations: { /* Mutations are responsible to change the state */

        setItems(state, {items, update_cache}) {
            state.items = items;

            if(update_cache || state.cache_items.length == 0){
                state.cache_items = items;
            }
        }


    }


}
